<template>
  <v-overlay :value="loading" :z-index="99999">
    <v-progress-circular
      indeterminate
      size="64"
    ></v-progress-circular>
  </v-overlay>
</template>

<script>
  export default {
    name: 'Loader',
    props: ['loading'],
    data: () => ({
    }),
    computed: {
    },
    methods: {
    },
    mounted() {
    },
    components: {
    }
  }
</script>
